import { render, staticRenderFns } from "./LinksMaxica.vue?vue&type=template&id=3c4b06bc&scoped=true"
import script from "./LinksMaxica.vue?vue&type=script&lang=js"
export * from "./LinksMaxica.vue?vue&type=script&lang=js"
import style0 from "./LinksMaxica.vue?vue&type=style&index=0&id=3c4b06bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b06bc",
  null
  
)

export default component.exports